<template>
  <div class="site-title">
    <div class="logo-container">
      <a href="/" aria-label="Building, Renovation and Project Planning Portal">
        <SiteLogo />
      </a>
    </div>
    <div>
      <h1 class="h2">Building, Renovation<br> and Project Planning Portal</h1>
    </div>
  </div>
</template>

<script setup>
import SiteLogo from './SiteLogo.vue'
</script>
